<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {

}

body {
  margin: 0 0;
}

.banner {
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 0;
}
li{
  list-style:none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue